import { Component, OnInit, ViewContainerRef, QueryList, ViewChildren, ComponentFactoryResolver, EventEmitter, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '@services/api/api.service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/components/common/menuitem';
import { NbActionsModule } from '@nebular/theme';
import { NbActionComponent, NbActionsComponent } from '@nebular/theme/components/actions/actions.component';
export interface IForm {
  displayName: string;
  component: any;
  index: number
}

@Component({
  selector: 'app-mf-nested-forms',
  templateUrl: './mf-nested-forms.component.html',
  styleUrls: ['./mf-nested-forms.component.css']
})
export class MfNestedFormsComponent implements OnInit {
  private formInstances: Array<any>;
  public hideForms: boolean = true;
  public breadcrumbs: any[] = new Array<any>();
  private _subscriptions: Array<Subscription> = new Array<Subscription>();
  public currentIndex: number = 0;
  private _currentRouteParams: any;
  public get currentRouteParams() {
    return this._currentRouteParams;
  }
  public set currentRouteParams(value) {
    this._currentRouteParams = value;
    this.currentRouteParamsChange.emit(value);
  }
  public currentRouteParamsChange = new EventEmitter();
  public saveClicked = new EventEmitter();
  public saveFinished = new EventEmitter();
  protected forms: Array<IForm>;
  public canAddNew: boolean = false;
  public canSave: boolean = false;

  public get formsToBuild(): Array<IForm> { return this.forms };

  @ViewChild('breadCrumbActions', { static: true }) public breadCrumbActions: ViewContainerRef;
  @ViewChildren('formDetails', { read: ViewContainerRef }) public formDetails: QueryList<ViewContainerRef>;
  constructor(private ApiService: ApiService,
    private authService: IdentityAuthService,
    private router: Router,
    private route: ActivatedRoute,
    private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit() {
    this._subscriptions.push(
      this.route.params.subscribe(
        params => {
          this.currentRouteParams = params;
          let maxIndex = 0;
          Object.keys(this.currentRouteParams).forEach(key => {
            if (key.indexOf("id_") != -1) {
              let idIndex = parseInt(key.substring(3, key.length));
              if (idIndex > maxIndex)
                maxIndex = idIndex;
            }
          });
          this.currentIndex = maxIndex;
          this.buildBreadCrumbs();
        }
      )
    );
  }

  public ngAfterViewInit() {
    if (this.formDetails && this.formDetails.length > 0) {
      this.buildForms();
    }
  }

  public addNewItem() {
    this.navigateNextNested(null);
  }


  private buildBreadCrumbs() {
    var self = this;
    this.breadcrumbs = new Array();
    this.formsToBuild.forEach(form => {
      if (form.index <= this.currentIndex)
        this.breadcrumbs.push({
          id: form.index,
          label: form.displayName, command: function () {
            let newRouteParams: any = {};
            Object.assign(newRouteParams, self.currentRouteParams);
            if (form.index > 0)
              newRouteParams["id_" + form.index] = "00000000-0000-0000-0000-000000000000";

            //strip out smaller params
            Object.keys(newRouteParams).forEach(key => {
              if (key.indexOf("id_") != -1) {
                let idIndex = parseInt(key.substring(3, key.length));
                if (idIndex > form.index)
                  delete newRouteParams[key];
              }
            });

            var originalRoute = self.router.url
            if (originalRoute.indexOf(';') != -1) //strip out existing params
              originalRoute = originalRoute.substring(0, self.router.url.indexOf(';'));
            self.router.navigate([originalRoute, newRouteParams]);
          }
        });
    })

  }

  private buildForms() {
    this.formInstances = new Array();
    for (let i = 0; i < this.formDetails.toArray().length; i++) {
      let component = this.formsToBuild[i];
      if (component) {
        let target = this.formDetails.toArray()[i];
        let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(component.component);
        let componentRef: any = target.createComponent(widgetComponent);
        let _component: any = (componentRef.instance);
        _component.entity = component.component;
        _component.entity.component = _component;
        _component.parent = this;
        _component.formIndex = component.index;
        this.formInstances.push(_component);
      }
    }
  }

  public navigateNextNested(id) {
    this.currentIndex += 1;
    let newRouteParams: any = {};
    Object.assign(newRouteParams, this.currentRouteParams);
    newRouteParams["id_" + this.currentIndex] = id;
    var originalRoute = this.router.url
    if (originalRoute.indexOf(';') != -1) //strip out existing params
      originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
    this.router.navigate([originalRoute, newRouteParams]);
  }

  public navigateBackNested() {
    let newRouteParams: any = {};
    Object.assign(newRouteParams, this.currentRouteParams);
    delete newRouteParams["id_" + this.currentIndex];
    this.currentIndex -= 1;
    var originalRoute = this.router.url
    if (originalRoute.indexOf(';') != -1) //strip out existing params
      originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
    this.router.navigate([originalRoute, newRouteParams]);
  }

  public navigateHome() {
    this.router.navigate(['/']);
  }

  private saveItem() {
    this.saveClicked.emit();
  }
}
